import api from '../../server';

export default {
  namespaced: true,
  state: {
    alipayurl: {},
    alipaywap: {},
    alipaymini: {}
  },
  actions: {
    fetchAlipayUrl ({ commit }, { params }) {
      return api.AlipayUrl(params).then(data => commit('setAlipayUrl', { data }))
    },
    fetchAlipayWap ({ commit }, { params }) {
      return api.AlipayWap(params).then(data => commit('setAlipayWap', { data }))
    },
    fetchAlipayMini ({ commit }, { params }) {
      return api.AlipayMini(params).then(data => commit('setAlipayMini', { data }))
    }
  },
  mutations: {
    setAlipayUrl (state, data) {
      state.alipayurl = data.data
    },
    setAlipayWap (state, data) {
      state.alipaywap = data.data
    },
    setAlipayMini (state, data) {
      state.alipaymini = data.data
    }
  }
}
